<template>
  <div
    class="flex justify-center items-center rounded-full shrink-0"
    :class="sizeClass"
    style="background: var(--white-opacity-8)"
  >
    <ThemeImage
      :icon="imageNames.REMOVED_USER"
      alt="removed_user"
      class="w-4 h-4"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  size: { type: Number, default: 28 },
});

const sizeClass = computed(() => {
  if (props.size === 32) return "w-8 h-8";
  if (props.size === 24) return "w-6 h-6";
  return "w-7 h-7";
});
</script>
